<template>
  <div class="sun-shine">
    <div class="sun-shine-title">{{ sunShineData.title }}</div>
    <div class="p1">{{ sunShineData.p }}</div>
    <div
      class="item"
      v-for="(item, index) in sunShineData.description"
      :key="index"
    >
      <div class="p2">{{ item.title }}</div>
      <div class="item-child" v-for="(child, i) in item.text" :key="i">
        {{ child }}
      </div>
    </div>
    <div class="company-footer">{{ sunShineData.company }}</div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      sunShineData: {},
    };
  },
  methods: {
    reqSunshine() {
      axios.get("./data.json").then((res) => {
        this.sunShineData = res.data.sunshineData;
      });
    },
  },
  mounted() {
    this.reqSunshine();
  },
};
</script>

<style scoped>
.sun-shine {
  width: 100%;
}
.sun-shine-title {
  width: 100%;
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  padding: 20px 0;
}
.p1,
.p2 {
  text-indent: 2em;
  line-height: 2;
  font-size: 17px;
  font-weight: 700;
}
.item-child {
  text-indent: 2em;
  line-height: 2;
  font-size: 16px;
}
.company-footer {
  text-align: right;
  line-height: 5;
  font-size: 17px;
  font-weight: 700;
}
</style>